import React, { useEffect, useState } from "react";


import {
  loadPosts,
  deletePost,
  loadTestimonials,
  deleteTestimonial,
} from "../utils/Network";
import { Link } from "react-router-dom";

import SelectTalent from "../components/SelectTalent";
import SelectLanguage from "../components/SelectLanguage";
import LanguageName from "../components/LanguageName";

export default function TestimonialsContent({ page, urlParams }) {
  const [loading, setLoading] = useState(0);
  const [pageloading, setPageLoading] = useState(false);
  const [testimonials, setTestimonials] = useState(null);
  const [testimonials_count, setTestimonialsCount] = useState(null);
  const [show_delete, setShowDelete] = useState(false);
  const [count, setCount] = useState(null);
  const [pages, setPages] = useState(null);
  const [filter_title, setFilterTitle] = useState(null);
  const [filter_language, setFilterLanguage] = useState(null);

  var filter_query = window.location.search;
  useEffect(() => {
    setPageLoading(true);
    getData();

    setFilterTitle(urlParams.get("title"));
  }, []);

  function getData() {
    //console.log(filter_query)
    loadTestimonials(filter_query, page).then((data) => {
      if (data.results) {
        setTestimonials(data.results);
      }
      if (data.count) {
        setTestimonialsCount(data.count);
        if (data && data.count) {
          setCount(data.count);
          var page_count =
            data.count % 10 === 0
              ? parseInt(data.count / 10)
              : parseInt(data.count / 10) + 1;
          var pages_array = range(1, page_count);
          setPages(pages_array);
        }
      }
      setPageLoading(false);
    });
  }
  function range(start, end) {
    return Array.apply(0, Array(end)).map((element, index) => index + start);
  }

  const handleDelete = (id, e) => {
    setLoading(id);
    deleteTestimonial(id).then(() => {
      getData();
    });
  };

  const showDelete = (e) => {
    e.preventDefault();
    setShowDelete(!show_delete);
  };

  const onValue = (value, name) => {
    // alert(name)
    switch (name) {
      case "language":
        setFilterLanguage(value);
        break;
      default:
        break;
    }
  };

  const onChange = (e) => {
    // alert(name)
    switch (e.target.name) {
      case "title":
        setFilterTitle(e.target.value);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className="content-wrapper">
        <section class="content-header">
          <h3 class="box-title mt-5"></h3>
          <ol class="breadcrumb">
            <li>
              <a href="dashboard">
                <i class="fa fa-dashboard"></i> Home
              </a>
            </li>
            <li class="active">Testimonials</li>
          </ol>
        </section>

        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div class="box box-primary">
                <div class="box-header with-border">
                  <h3 class="box-title mt-5">
                    All Items &nbsp;
                    <small>({testimonials_count}) items</small>
                  </h3>
                  <a
                    href="testimonial"
                    title="Add New"
                    className="btn btn-orange pull-right "
                  >
                    <i className="fa fa-plus"></i>
                  </a>
                  <a
                    href="delete"
                    title="Show Delete Button"
                    className="btn btn-danger margin-r-5 pull-right "
                    onClick={showDelete}
                  >
                    <i className="fa fa-trash"></i>
                  </a>
                </div>
                <div className="box-body no-padding ">
                  <form action="" method="get">
                    <table id="example1" className="table table-striped mb-0">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Language</th>
                          <th>Date</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {testimonials?.map((item) => (
                          <tr
                            key={item.id}
                            className={loading === item.id ? "loading" : ""}
                          >
                            <td>
                              <p>
                                <a href={`testimonial/${item.id}`}>
                                  {item.title}
                                </a>
                              </p>
                            </td>
                            <td>
                              <a
                                href={`testimonials?language=${item.language}`}
                              >
                                <LanguageName id={item.language} />
                              </a>
                            </td>
                            <td>
                              {item.created_at.split("T")[0]}
                              <br />
                              {item.created_at.split("T")[1].split(".")[0]}
                            </td>
                            <td>
                              <div className="btn-group">
                                {show_delete && (
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      if (
                                        window.confirm(
                                          "Are you sure you wish to delete this item?"
                                        )
                                      )
                                        handleDelete(item.id, e);
                                    }}
                                    className="btn btn-default btn-sm"
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                )}
                                <a
                                  href={`testimonial/${item.id}`}
                                  className="btn btn-default btn-sm"
                                >
                                  <i className="fa fa-edit"></i>
                                </a>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th>Name</th>
                          <th>Language</th>
                          <th>Date</th>
                          <th></th>
                        </tr>
                      </tfoot>
                    </table>
                  </form>
                </div>
              </div>

              <ul className="pagination cms-pagination m-0 float-right">
                <li className="page-item">
                  <Link className="page-link" to="#">
                    «
                  </Link>
                </li>
                {pages &&
                  pages.map((page_number) => (
                    <li key={page_number} className="page-item">
                      <a
                        className={
                          page_number == page ? "page-link active" : "page-link"
                        }
                        href={`testimonials/${page_number}${
                          urlParams ? "?" + urlParams : ""
                        }`}
                      >
                        {page_number}
                      </a>
                    </li>
                  ))}
                <li className="page-item">
                  <Link className="page-link" to="">
                    »
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
